module.exports = __webpack_public_path__ + "media/arcade-complete.9ff51cb8.mp3";